import { useEffect, useState } from "react";
import { Star } from "lucide-react";

interface FloatingPointsProps {
  points: number;
  show: boolean;
  onComplete?: () => void;
}

export function FloatingPoints({ points, show, onComplete }: FloatingPointsProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (show) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
        onComplete?.();
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [show, onComplete]);

  if (!visible) return null;

  return (
    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 pointer-events-none">
      <div className="animate-[fade-in_0.3s_ease-out,_scale-in_0.3s_ease-out] flex items-center gap-2 bg-gradient-to-r from-yellow-500/90 to-orange-500/90 text-white px-6 py-3 rounded-full shadow-lg">
        <Star className="h-6 w-6 animate-pulse" />
        <span className="text-2xl font-bold">+{points}</span>
      </div>
    </div>
  );
}
